// The board-ready event of docs/plans/omni-whiteboard-board-map.md decision 12.
export function watchBoardReady({
  getService,
  before = {},
  onReady,
  timeoutMs = 4000,
  pollMs = 50,
  now = () => Date.now(),
  setTimer = setTimeout,
  nextFrame = (fn) => requestAnimationFrame(fn),
}) {
  const start = now()
  let done = false
  let timer = null

  const stop = () => {
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
    }
  }

  const finish = (result) => {
    if (done) return
    done = true
    stop()
    onReady(result)
  }

  const poll = () => {
    if (done) return

    if (now() - start >= timeoutMs) {
      finish({ timedOut: true })
      return
    }

    const camera = getService('omni.camera')
    const document = getService('omni.document')
    const ready =
      camera && document && camera !== before['omni.camera'] && document !== before['omni.document'] && camera.viewportSize()?.width > 0

    if (ready) {
      done = true
      stop()
      nextFrame(() => {
        nextFrame(() => {
          onReady({ timedOut: false })
        })
      })
      return
    }

    timer = setTimer(poll, pollMs)
  }

  timer = setTimer(poll, pollMs)

  return () => {
    done = true
    stop()
  }
}
